import { ViewportScroller } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ScreenService } from 'src/services/cdk/screen.service'
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';

type FooterSchemeTheme = 'porcelain' | 'instrument' | 'abundance';

interface FooterSchemeConfig {
  theme: FooterSchemeTheme;
  title: string;
  description: string;
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  screenType: string = "desktop";
  schemeConfig: FooterSchemeConfig | null = null;
  private pendingScrollReset = false;
  private readonly schemeMap: Record<string, FooterSchemeConfig> = {
    '/porcelain': {
      theme: 'porcelain',
      title: '获取专属定制方案',
      description: '想要提升印刷效率和质量？立即联系我们，了解如何通过我们的RIP排版打印软件实现您的业务目标！'
    },
    '/instrument': {
      theme: 'instrument',
      title: '获取专属定制方案',
      description: '想了解丹书如何适配你的文档编辑流程、资料维护场景或企业协作需求，可以直接联系我们。'
    },
    '/abundance': {
      theme: 'abundance',
      title: '获取专属定制方案',
      description: '想了解丰芒如何提升排料效率、减少材料浪费并适配你的生产场景，可以直接联系我们。'
    }
  };

  constructor(
    private screenService: ScreenService,
    private router: Router,
    private viewportScroller: ViewportScroller
  ) {
  }

  ngOnInit() {
    this.subscriptions.push(
      this.screenService.onResize$.subscribe(size => {
        this.screenType = size < 1200 ? "mobile" : "desktop";
      }),
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          this.updateSchemeConfig(event.urlAfterRedirects);
          if (this.pendingScrollReset) {
            this.forceScrollToTop();
            this.pendingScrollReset = false;
          }
        }
      })
    );
    this.updateSchemeConfig(this.router.url);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  private updateSchemeConfig(url: string) {
    const cleanUrl = url.split('?')[0].split('#')[0];
    this.schemeConfig = this.schemeMap[cleanUrl] ?? null;
  }

  navigateToHome(){
    this.navigateTo('/home');
  }

  navigateTo(path: string) {
    const targetPath = path.startsWith('/') ? path : `/${path}`;
    const currentPath = this.router.url.split('?')[0].split('#')[0];
    const activeElement = document.activeElement as HTMLElement | null;
    activeElement?.blur?.();

    if (currentPath === targetPath) {
      this.forceScrollToTop();
      return;
    }

    this.pendingScrollReset = true;
    this.router.navigate([targetPath]).then(() => {
      this.forceScrollToTop();
    });
  }

  openTrialPage() {
    this.navigateTo('/trial');
  }

  openContactPage() {
    this.navigateTo('/contact');
  }

  private forceScrollToTop() {
    this.viewportScroller.scrollToPosition([0, 0]);
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    });
  }

}
